<template>
  <div class="flex flex-col gap-3 bg-[#FFD602] p-2 min-h-10 rounded-xl w-full relative">
    <template v-if="loading">
      <div class="w-full text-center">Đang tải dữ liệu ...</div>
    </template>
    <template v-if="rewards && rewards.length > 0">
      <div
          v-for="(item, index) in rewards"
          :key="index"
          class="bg-yellow-400 text-black text-sm leading-relaxed border-b border-b-black last:border-none"
      >
        <div class="flex justify-between items-start p-2 gap-2">
          <div class="flex flex-col">
            <p class="font-semibold">Họ và tên</p>
            <p class="mb-1 line-clamp-1">{{ item.name }}</p>
            <p class="font-semibold">Số điện thoại</p>
            <p>{{ item.phone }}</p>
          </div>
          <div class="flex flex-col text-right">
            <p class="font-semibold">Phần quà</p>
            <p class="mb-1">{{ item.prize }}</p>
            <p class="font-semibold">Thời gian</p>
            <p>{{ item.time }}</p>
          </div>
        </div>
      </div>
    </template>
    <template v-if="rewards && rewards.length === 0 && !loading">
      <div class="w-full text-center pt-3">Chưa có dữ liệu</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "TableMobile",
  props: {
    rewards: {
      type: Array,
      default: () => [],
    },
    typeReward: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
};
</script>
